import { Subject } from 'rxjs';

export class ColumnFilterLoader {
  key!: string;
  filterLoaded: Subject<void> = new Subject();
  isLoaded = false;

  constructor(key: string) {
    this.key = key;
  }

  completed(): void {
    this.isLoaded = true;
    this.filterLoaded.next();
  }
}
